import { Injectable } from "@angular/core";

/**
 * Service to store images and videos in memory instead of localStorage
 * This prevents issues with large base64 strings exceeding localStorage limits
 */
@Injectable({
    providedIn: "root",
})
export class MemoryStorageService {
    private storage: Map<string, any> = new Map();

    /**
     * Store a value in memory
     */
    public set(key: string, value: any): void {
        this.storage.set(key, value);
    }

    /**
     * Retrieve a value from memory
     */
    public get<T = any>(key: string): T | null {
        return this.storage.get(key) ?? null;
    }

    /**
     * Remove a value from memory
     */
    public remove(key: string): void {
        this.storage.delete(key);
    }

    /**
     * Clear all values from memory
     */
    public clear(): void {
        this.storage.clear();
    }

    /**
     * Check if a key exists in memory
     */
    public has(key: string): boolean {
        return this.storage.has(key);
    }

    /**
     * Get all keys in memory
     */
    public keys(): string[] {
        return Array.from(this.storage.keys());
    }
}
